import React, { useEffect } from "react";
import Router from "next/router";
import Head from "next/head";
import { TeacherJoinPage } from "~/views/TeacherJoinPage";
import { facebook, urls } from "~/settings";

export default function TeacherJoinPageWrapper() {
  function renderMetadata() {
    const meta = {
      title: "Live, online group classes with Obby",
      desc:
        "Obby is now offering face to face live group classes, online with our teachers! Stay social and learn something new with Obby",
      image: "https://obby.co.uk/static/images/metadata_card.jpg"
    };

    const ldData = {
      "@context": "http://schema.org/",
      "@type": "Website",
      name: "Obby",
      description:
        "We’ve partnered with Collective Benefits to provide our teachers with a range of benefits such as sick pay, family and compassionate leave.",
      image: "https://obby.co.uk/static/images/metadata_card.jpg",
      url: "https://obby.co.uk",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://obby.co.uk/classes?q=search_term_string",
        "query-input": "required name=search_term_string"
      },
      sourceOrganization: {
        "@type": "Organization",
        name: "Obby",
        description:
          "We’ve partnered with Collective Benefits to provide our teachers with a range of benefits such as sick pay, family and compassionate leave.",
        image: "https://obby.co.uk/static/images/metadata_card.jpg",
        url: "https://obby.co.uk",
        address: {
          "@type": "PostalAddress",
          addressLocality: "London",
          postalCode: "W1U 6BP",
          streetAddress: "1 Bickenhall Mansions, Bickenhall Street"
        },
        logo: {
          "@type": "ImageObject",
          url: "https://obby.co.uk/static/images/metadata_card.jpg"
        }
      }
    };
    return (
      <Head>
        <title>{meta.title}</title>
        <meta name="description" content={meta.desc} />
        <meta property="fb:app_id" content={facebook.appId} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:description" content={meta.desc} />
        <meta property="og:url" content="https://obby.co.uk" />
        <meta property="og:image" content={meta.image} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Obby" />
        <meta property="twitter:title" content={meta.title} />
        <meta property="twitter:description" content={meta.desc} />
        <meta property="twitter:card" content="summary" />
        <meta property="twitter:image" content={meta.image} />
        <meta property="twitter:image:alt" content={meta.title} />
        <link rel="canonical" href="https://obby.co.uk" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: `${JSON.stringify(ldData)}` }}
        />
      </Head>
    );
  }

  function onClickGetStarted() {
    let dataTrack = {
      event: "Teacher Join Page: User Clicks Getting Started Button",
      name: "Teacher Join Page: User Clicks Getting Started Button",
      source: "marketplace"
    };
    if (window.dataLayer) {
      window.dataLayer.push(dataTrack);
    }
    window.open(`${urls.teachers}/signup`, "_blank");
  }

  function onClickViewClass({ link }) {
    Router.push(link);
  }

  useEffect(() => {
    let dataTrack = {
      name: "Teacher Join Page",
      path: window.location.pathname || "",
      referrer: document.referrer || "",
      title: document.title || "",
      url: window.location.href
    };
    if (window.rudderanalytics)
      window.rudderanalytics.page(dataTrack.name, dataTrack);
  }, []);

  return (
    <>
      {renderMetadata()}
      <TeacherJoinPage
        onClickGetStarted={onClickGetStarted}
        onClickViewClass={onClickViewClass}
      />
    </>
  );
}
TeacherJoinPageWrapper.noHeader = true;
